import { repository } from "repositories";
import { OrderType } from "repositories/TopicRepository";
import {
  GetTopicListRes,
  SWRResponse,
  TODO_Transfer,
  WithPaginationMetaResponse,
} from "shared/types";
import useSWR from "swr";

export const useTopicList = (
  mediaType: "press" | "miracle",
  params?: {
    limit?: number;
    order?: OrderType;
    page?: string | string[] | number;
    meta?: boolean;
  }
): SWRResponse<WithPaginationMetaResponse<Omit<GetTopicListRes, "meta">>> => {
  const repo = repository.topic.getList(mediaType, params);

  const { data, error, mutate } = useSWR(
    params ? [repo.path, ...Object.values(params)] : repo.path,
    repo.data
  );

  return {
    topics: data?.topics,
    meta: {
      totalPages: data?.meta?.total,
    },
    isLoading: !data && !error,
    isError: !!error,
    mutate: mutate as TODO_Transfer,
  };
};
